(function(){
'use strict';
/*
 * Fix: live testing on the draft preview showed the unified cart engine
 * (divarouj-cart-stable.js) sometimes adds an item to Shopify's real
 * cart successfully (confirmed via /cart.js item_count increasing) but
 * never opens/updates the cart drawer or shows the confirmation toast --
 * the drawer's "open" class and re-render never happen for that click,
 * so the customer sees nothing and assumes the button did not work.
 * Testing also showed this can happen even before the engine's own
 * cart:updated event fires, so this does not rely on that event alone.
 * The primary signal is a direct, read-only observation of the actual
 * network call: whenever a POST to cart/add.js (or cart/change.js,
 * cart/update.js) succeeds, this checks a moment later whether the
 * drawer is visibly open, and if not, opens it through the theme's own
 * public API (window.DivaStableCart.open), which re-fetches the current
 * cart and renders it. This does not add a second cart system, does not
 * change any request or response, and does not fire when the native
 * flow already opened the drawer (the normal/working case).
 */
  function drawerIsOpen(){
    var d = document.getElementById('divaStableCart');
    return !!(d && d.classList.contains('open'));
  }
  function ensureDrawerOpen(){
    if (drawerIsOpen()) return;
    if (window.DivaStableCart && typeof window.DivaStableCart.open === 'function') {
      window.DivaStableCart.open();
    } else {
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    }
  }
  function scheduleCheck(){
    setTimeout(ensureDrawerOpen, 700);
    setTimeout(ensureDrawerOpen, 1600);
  }

  document.addEventListener('cart:updated', scheduleCheck);

  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function(input, init){
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCartMutation = /\/cart\/(add|change|update)\.js/.test(url);
      var method = (init && init.method) || (typeof input !== 'string' && input && input.method) || 'GET';
      var promise = originalFetch.apply(this, arguments);
      if (isCartMutation && String(method).toUpperCase() === 'POST') {
        promise.then(function(response){
          if (response && response.ok) scheduleCheck();
        }).catch(function(){});
      }
      return promise;
    };
  }

/*
 * Fix: quick-add buttons (any submit button inside a form posting to
 * /cart/add, e.g. the .dvx-quick collection-card buttons) go into a
 * disabled/"is-diva-adding" busy state while the request is in flight,
 * which is correct -- but live testing also showed cases where that
 * busy state does not get cleared, leaving the button permanently
 * unresponsive ("not listening") until the page is reloaded. This adds
 * a watchdog: if a trigger stays busy for more than 8 seconds (far
 * longer than a normal add-to-cart request), it is cleared so the
 * button becomes clickable again. It never interferes with a request
 * that legitimately finishes within 8 seconds.
 */
  var busyTimers = new WeakMap();
  function watchBusyState(el){
    if (busyTimers.has(el)) return;
    var timer = setTimeout(function(){
      if (el.classList.contains('is-diva-adding')) {
        el.classList.remove('is-diva-adding');
        el.removeAttribute('aria-busy');
        el.removeAttribute('aria-disabled');
        if ('disabled' in el) el.disabled = false;
      }
      busyTimers.delete(el);
    }, 8000);
    busyTimers.set(el, timer);
  }
  document.addEventListener('click', function(e){
    var trigger = e.target.closest('form[action*="/cart/add"] [type="submit"], form[action*="/cart/add"] button:not([type])');
    if (trigger) watchBusyState(trigger);
  }, true);
})();
